import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        flex: 1,
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: '20%',
        paddingBottom: 20
    },
    title: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: Theme.fontSizes.title,
        marginBottom: 16,
        textAlign: 'center'
    },
    successIcon: {
        height: 100,
        width: 100,
        marginBottom: 16
    },
    button: {
        marginBottom: 10
    },
    buttonWidth: {
        minWidth: 300
    }
};

export default StyleSheet.create(baseStyles);
